export const parseJwtPayload = (token: string): Record<string, unknown> | null => {
  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }

  const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
  try {
    const decoded = atob(payload.padEnd(payload.length + (4 - (payload.length % 4 || 4)), '='));
    return JSON.parse(decoded) as Record<string, unknown>;
  } catch {
    return null;
  }
};

export const getTenantIdFromToken = (token?: string | null): string | null => {
  if (!token) {
    return null;
  }

  const payload = parseJwtPayload(token);
  const tenantId = payload?.['custom:tenant_id'] ?? payload?.tenant_id;
  return typeof tenantId === 'string' && tenantId.trim() ? tenantId : null;
};

export const getUserDisplayNameFromToken = (token?: string | null): string | null => {
  if (!token) {
    return null;
  }

  const payload = parseJwtPayload(token);
  const name = payload?.name ?? payload?.preferred_username ?? payload?.email;
  return typeof name === 'string' && name.trim() ? name : null;
};
